import { ApisauceInstance } from 'apisauce';

/**
 * Removes every override on a bonus dataset record (criteria, qualifier, value,
 * reward) and its reason codes, rebuilding the record from its cached inputs.
 * Used when a confirm leaves the record with no overrides at all — the unified
 * PUT rejects an empty body, so a full clear routes here instead.
 */
const deleteDriverOverrides = ({
  api,
  driver,
  bonusProgramId,
  intervalId,
  bonusDatasetRecordId,
}: {
  api: ApisauceInstance;
  driver: string;
  bonusProgramId: string;
  intervalId: string;
  bonusDatasetRecordId: string;
}) => {
  return api.delete<BonusTypes.Rewards.AnyDriverRewardsOutput>(
    `/v1/driver_bonus/overrides?driver=${driver}&period=${intervalId}&driver_bonus_program_id=${bonusProgramId}&bonus_dataset_record_id=${bonusDatasetRecordId}`,
  );
};

export default deleteDriverOverrides;
